import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,[_c('default-bar'),_c('default-drawer'),_c(VMain,[_c('router-view',{key:_vm.$route.path})],1),_c('alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }